<template>
  <BaseButton primary @click="showAddMemberModal"> Add Member </BaseButton>
</template>

<script>
import accountMembershipsClient from '@/api/clients/accountMembershipsClient';
import mapKeysToSnakeCase from '@/utils/map-keys-to-snake-case';

export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
    roles: {
      type: Array,
      required: true,
    },
  },
  methods: {
    showAddMemberModal() {
      this.$modal.show({
        component: () => import('Components/AccountMembers/AccountMemberAddModal.vue'),
        props: {
          action: this.addMember,
          roles: this.roles,
        },
        on: {},
        hideEvent: 'hide',
      });
    },
    async addMember(data) {
      try {
        const response = await accountMembershipsClient.store(
          this.accountId,
          mapKeysToSnakeCase(data)
        );

        this.$emit('member-add');

        return Promise.resolve(response.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
